import React, { useState, useEffect } from 'react';
import { Col, Image, Modal, Row, Button } from 'react-bootstrap';
import icAdd from '../../../assets/images/ic-add.svg';
import ENGModalBody from '../../../components/modal/ENGModalBody';
import ENGModalHeader from '../../../components/modal/ENGModalHeader';
import { Form } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  AddDataAsync,
  AddCategoryData
} from '../../../features/learning/CategorySlice';
import { isPermited } from '../../../features/localStorage';

const AddCategory = () => {
  const dispatch = useAppDispatch();

  const addCategory = useAppSelector(AddCategoryData);

  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [isAPI, setIsAPI] = useState(false);

  useEffect(() => {
    if (addCategory && isAPI) {
      setIsAPI(false);
      handleCloseModal();
    }
  }, [addCategory]);

  const handleCloseModal = () => {
    setShowModal(false);
    setTitle('');
    setDescription('');
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleFormTitle = (event: any) => {
    setTitle(event?.target.value);
  };

  const handleFormDescription = (event: any) => {
    setDescription(event?.target.value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const obj = {
      categoryName: title,
      categoryDescription: description
    };
    setIsAPI(true);

    // console.log("======= form object ======>", obj);
    dispatch(AddDataAsync(obj));
    // setShowModal(false);
  };

  // console.log("Title========>", title);
  // console.log("addCategory data ========>", addCategory);

  return (
    <>
      {isPermited(13, 2) && (
        <a
          onClick={handleShowModal}
          style={{
            backgroundColor: '#fff',
            color: '#e31837',
            fontFamily: 'Saira',
            fontWeight: 600,
            fontSize: '12px',
            textTransform: 'uppercase'
          }}
        >
          <span style={{ fontSize: '18px' }}>
            <Image
              src={icAdd}
              style={{
                width: '24px',
                height: '24px'
              }}
            />
          </span>

          <span
            style={{ fontSize: '12px', cursor: 'pointer', fontWeight: 600 }}
          >
            ADD CATEGORY
          </span>
        </a>
      )}

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        backdrop='static'
        size='lg'
        keyboard={false}
      >
        <Form onSubmit={handleSubmit}>
          <ENGModalHeader icon={''} title='Add Category' />
          <ENGModalBody
            contents={
              <>
                <Row style={styles.divWhiteForm}>
                  <Col>
                    <Row>
                      <Col sm={12} xs={12} className='pb-3 pt-2'>
                        <Form.Control
                          className='shadow-none'
                          style={styles.text1}
                          type='text'
                          placeholder='Add Title'
                          id='FormTitle'
                          name={title}
                          onChange={handleFormTitle}
                          required
                        />
                      </Col>

                      <Col sm={12} xs={12} className='pb-3 pt-2'>
                        <Form.Control
                          className='shadow-none'
                          style={styles.text1}
                          type='text'
                          placeholder='Add Description'
                          id='FormDescription'
                          name={description}
                          onChange={handleFormDescription}
                          required
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            }
          />
          <Modal.Footer style={styles.bgGrey}>
            <Button type='submit' style={styles.button}>
              SUBMIT
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

const styles: any = {
  divWhiteForm: {
    backgroundColor: '#fffff',
    padding: '24px'
  },
  divGrey: {
    backgroundColor: '#faf9f9',
    paddingTop: '40px',
    paddingLeft: '40px'
  },
  divWhite: {
    backgroundColor: '#fffff',
    paddingTop: '40px',
    paddingLeft: '40px',
    paddingRight: '40px',
    paddingBottom: '30px'
  },
  bgGrey: {
    backgroundColor: '#faf9f9'
  },
  p0: {
    padding: '0px'
  },
  continue: {
    float: 'right',
    textAlign: 'right',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 2,
    letterSpacing: 'normal'
  },
  button: {
    padding: '13px 40px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: 400,
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#e31837',
    letterSpacing: 'normal',
    border: '0px'
  },
  name: {
    fontFamily: 'Saira',
    fontSize: '18px',
    fontWeight: '600',
    fontStrech: 'normal',
    textAlign: 'left',
    marginTop: '32px'
  },
  designation: {
    fontFamily: 'Saira',
    fontSize: '18px',
    fontWeight: 'normal',
    fontStrech: 'normal',
    textAlign: 'left',
    marginBottom: '32px'
  },
  message: {
    fontFamily: 'Saira',
    fontSize: '18px',
    fontWeight: 'normal',
    fontStrech: 'normal',
    textAlign: 'left'
  }
};

export default AddCategory;
